const SIDE_MENU = 'SIDE_MENU';
export const SIDE_MENU_MANAGE = `${SIDE_MENU}_MANAGE`;
